import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';

import * as yup from 'yup';

export interface DocumentsStatisticsFindInterface {
  /** Income documents with cash method total amount */
  kassIncomeAmount: number;
  /** Expense documents with cash method total amount */
  kassExpenseAmount: number;
  /** Income and expense documents with cash method total amount difference */
  kassDiff: number;
  /** Income documents with sale method total amount */
  saleIncomeAmount: number;
  /** Expense documents with sale method total amount */
  saleExpenseAmount: number;
  /** Income and expense documents with sale method total amount difference */
  saleDiff: number;
  /** Balance income for KASS method (`"deal_amount" - "kass_income_amount"`) */
  kassIncomeBalance: number;
  /** Balance expense for KASS method (`"deal_plan" - "kass_expense_amount"`) */
  kassExpenseBalance: number;
  /** Balance income for SALE method (`"deal_amount" - "sale_income_amount`) */
  saleIncomeBalance: number;
  /** Balance expense for SALE method (`"deal_plan" - "sale_expense_amount"`) */
  saleExpenseBalance: number;
}

export const DocumentsStatisticsFindDto = SerdeDtoClass.create<DocumentsStatisticsFindInterface>(BusinessDtoKeysEnum.DOCUMENT_STATISTIC_FIND_DTO, {
  kassIncomeAmount: {
    label: 'Кассовая сумма дохода',
    serializer: yup.number(),
  },
  kassExpenseAmount: {
    label: 'Кассовая сумма расходов',
    serializer: yup.number(),
  },
  kassDiff: {
    label: 'Разница',
    serializer: yup.number(),
  },
  saleIncomeAmount: {
    label: 'Сумма дохода от продажи',
    serializer: yup.number(),
  },
  saleExpenseAmount: {
    label: 'Сумма расходов на продажу',
    serializer: yup.number(),
  },
  saleDiff: {
    label: 'Разница продажи',
    serializer: yup.number(),
  },
  kassIncomeBalance: {
    label: 'Баланс доходов по кассовому методу',
    serializer: yup.number(),
  },
  saleIncomeBalance: {
    label: 'Баланс доходов по "продажному" методу',
    serializer: yup.number(),
  },
  kassExpenseBalance: {
    label: 'Баланс расходов по кассовому методу',
    serializer: yup.number(),
  },
  saleExpenseBalance: {
    label: 'Баланс расходов по "продажному" методу',
    serializer: yup.number(),
  },
});
